import selectFolderAndRow from './selectFolderAndRow';
import selectRow from './selectRow';
export interface MailRowRouteParameters {
    folderId?: string;
    rowId: string;
}
export default function mailRowRouteHandler(parameters: MailRowRouteParameters) {
    selectRow(parameters.rowId);
}
export function mailRowFolderRouteHandler(parameters: MailRowRouteParameters) {
    const { folderId, rowId } = parameters;
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2345 (15,24): Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    // @ts-ignore
    selectFolderAndRow(folderId, rowId);
}
